export const postBackInStockNotification = ({ email, name, phone, location, bikeTitle, listName }) => {
  return fetch(`/.netlify/functions/backInStockNotification`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
      name,
      phone,
      location,
      bikeTitle: bikeTitle,
      listName
    }),
  })
}
